var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-mt-2 tw-px-3 tw-py-3",attrs:{"theme":"danger"}},[_vm._v(" You are not allowed to request overtime which crosses the boundary of the leave allowance year. Please raise separate requests for this year and next year. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }